/*-----------------------------------------------------------------*/
/*								ハートの吹き出し部分							 */
/*-----------------------------------------------------------------*/
$(function(){
	$("body").append("<div id='heart_explanation'></div>");

	$(".cart_heart").hover(function(){

		var offset = $(this).offset();

		$("#heart_explanation").html("クリックするとお気に入りに入り、<br>お買い物かごの中でゆっくりと比較できます");

		$(this).find(".pink").each(function(){
			$("#heart_explanation").html("お気に入りに入っています");
		});

		$("#heart_explanation").show();
		$("#heart_explanation").hide();
		var half_width = $("#heart_explanation").width()/2;

		$("#heart_explanation").css('top',(offset.top-($("#heart_explanation").height()+20))+"px");
		$("#heart_explanation").css('left',(offset.left-half_width+10)+"px");
		$("#heart_explanation").show();
		
	},function(){
		$("#heart_explanation").hide();
	});
});
